// extracted by mini-css-extract-plugin
export default {"payment_form":"DonationBox_payment_form__Pa8P2","submit_btn":"DonationBox_submit_btn__XiH5F"};